import { useEffect, useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import { useParams } from "react-router";
import Api from "../../../api/Api";
import { AuditorsTestShortNames, AuditorsTestStructure, AuditorsTestStructureAll } from "../PlaningAuditPage/AuditorsTestStructure";
import { Accordion, Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import Select from "react-select";


const changeAuditData = async(data, audit_id) => {
    try {
        const response = await Api({
            method:"PATCH",
            url:`/audits/@${audit_id}/edit`,
            headers:{},
            data:data
        })
        alert("Данные об аудите изменены");
        window.location.href="/main_page"
    } catch (error) {
        alert(`Ошибка при изменении аудита \n ${error}`);
    }
}

const filterEmptyArrays = (data) =>
    Object.keys(data).reduce((acc, partName) => {
        const filteredCategories = Object.keys(data[partName])
            .filter(cat => data[partName][cat].length > 0)
            .reduce((obj, cat) => ({ ...obj, [cat]: data[partName][cat] }), {});
        if (Object.keys(filteredCategories).length > 0) {
            acc[partName] = filteredCategories;
        }
        return acc;
    }, {});

const comparisonData = (data, auditData) => {
        const result={}
        Object.keys(data).forEach((key)=>{
            switch (key){
                case "auditors":
                    if (JSON.stringify(filterEmptyArrays(data.auditors))!==JSON.stringify(auditData.auditors)){
                        result["auditors"]=data.auditors;
                    }
                    break;
                case "esteem_audit":
                    if(data["esteem_audit"]!=auditData["esteem_audit_id"]){
                        result["esteem_audit"]=data["esteem_audit"]
                    }
                    break;
                case "start_datetime":
                    if(new Date(data["start_datetime"]).toISOString()!==new Date(auditData["start_datetime"]).toISOString()){
                        result["start_datetime"]=data["start_datetime"];
                    }
                    break;
                case "end_datetime":
                    if(new Date(data["end_datetime"]).toISOString()!==new Date(auditData["end_datetime"]).toISOString()){
                        result["end_datetime"]=data["end_datetime"];
                    }
                    break;
                default:
                    if(data[key]!=auditData[key]){
                        result[key]=data[key]
                    }
            }
        })
        return result
        
    }

const prepareData = (auditorsCurrentData,auditorsAllData) => {
    const result={};
    Object.keys(auditorsCurrentData).forEach((partName)=>{
        const resultAllCategoires={}
        if(auditorsAllData[partName].length!==0){
            Object.keys(auditorsCurrentData[partName]).forEach((categoryName)=>{
                resultAllCategoires[categoryName]=auditorsAllData[partName];
            })
            result[partName]=resultAllCategoires;
        }else{
            Object.keys(auditorsCurrentData[partName]).forEach((categoryName)=>{
                resultAllCategoires[categoryName]=auditorsCurrentData[partName][categoryName] || [];
            })
            result[partName]=resultAllCategoires;
        } 
    })

    const send_result = {};
    Object.keys(result).forEach((partName)=>{
        if (Object.keys(result[partName]).length!==0){
            send_result[partName]=result[partName];
        }
    })
    return send_result
}

const AuditFormInterface = ({auditData, usersOptions, facilityOptions,
     selfEsteemOption, AuditorsTestBlock, AuditorsTestBlockAll, 
     AuditorsCurrentTestBlock, shortNames
}) => {
    const {audit_id}=useParams()

    const [leaderValue,setLeaderValue]=useState(
        usersOptions.find(opt=> opt.value === auditData.audit_leader)
    );
    const [facilityValue,setFacilityValue]=useState(
        facilityOptions.find(opt=> opt.value === auditData.facility_id)
    );
    const [esteemAuditValue,setEsteemAuditValue]=useState(
        selfEsteemOption.find(opt=> opt.value === auditData.esteem_audit_id)
    );

    const testId=auditData.test_id;

    const [auditorsCurrentData, setAuditorsCurrentData]=useState(AuditorsCurrentTestBlock);
    const [auditorsAllData,setAuditorsAllData]=useState(AuditorsTestBlockAll);

    const setUpFormFirst = () => {
        const fieldIds=["name", "description", "audit_type", "activation","start_datetime","end_datetime"]
        fieldIds.forEach((elem)=>{
            document.getElementById(elem).value=auditData[elem];
        })
        const fieldsCheck=["notify_auditors","results_access"]
        fieldsCheck.forEach((elem)=>{
            document.getElementById(elem).checked=auditData[elem];
            document.getElementById(elem).value=auditData[elem];
        })
    }

    const findOptionByName = (name) => usersOptions.find(option => option.value === name);

    const handleSaveCheckedAllValues = (partName, selected) => {
        auditorsAllData[partName]=selected.map((option)=>option.value);
    }
    const handleSaveCheckedCurrentValues = (partName, categoryName, selected) => {
        auditorsCurrentData[partName][categoryName]=selected.map((option)=>option.value);
    }

    useEffect(()=>{
        setUpFormFirst();
    },[])

    const handleSave = async(e) => {
        e.preventDefault();

        const get_create_name = () =>{
            if(document.getElementById("name").value!==auditData.name){
                const new_name=[new Date(document.getElementById("start_datetime").value).toISOString().split("T")[0] || "",
                facilityValue.label || "",
                document.getElementById("name").value || ""]
                return(new_name.join("-"))
            }
            return document.getElementById("name").value
        }
        const data={
            "audit_type": document.getElementById("audit_type").value,
            "name": get_create_name(),
            "description": document.getElementById("description").value,
            "start_datetime": document.getElementById("start_datetime").value,
            "end_datetime": document.getElementById("end_datetime").value,
            "activation": document.getElementById("activation").value,
            "results_access": document.getElementById("results_access").checked,
            "test_id": testId,
            "notify_auditors": document.getElementById("notify_auditors").checked,

            "audit_leader": leaderValue.value,
            "esteem_audit": esteemAuditValue?.value || null,
            "facility_id": facilityValue.value,
        }

        data["auditors"]=prepareData(auditorsCurrentData,auditorsAllData);
        const send_data=comparisonData(data, auditData)
        if(Object.keys(send_data).length==0){
            alert("Перед сохранением измените любое значение")
        }else{
            await changeAuditData(send_data, audit_id);
        }
    }

    return(
        <>
            <Form onSubmit={(e)=>handleSave(e)}>
                <Card className="my-2 text_font">
                    <Card.Header>Информация о тесте</Card.Header>
                    <Card.Body>
                        <Form.Control
                        value={`${auditData.test_name} (id: ${auditData.test_id})`}
                        disabled
                        readOnly
                        />
                    </Card.Body>
                </Card>
                <Card className="my-2">
                    <Card.Header className="text_font">Информация об аудите</Card.Header>
                    <Card.Body>
                        <div>
                            <div>
                                <Form.Control 
                                id="name"
                                className="mb-1"
                                type="text"
                                placeholder="Название аудита..."
                                />

                                <Form.Control 
                                id="description"
                                className="mb-1"
                                as="textarea" 
                                placeholder="Описание аудита"/>
                            </div>
                        </div>
                        <div>
                        <Row className="mb-1">
                            <Col md={4}>
                                <Form.Text>Рассылка по email</Form.Text>
                                <Form.Check
                                type="switch"
                                id="notify_auditors"
                                label="Не рассылать/Рассылать"
                                /> 
                            </Col>
                            <Col md={4}>
                                <Form.Text>Тип аудита</Form.Text>
                                <Form.Select
                                id="audit_type">
                                    <option value="common">Обычный</option>
                                    <option value="self-esteem">Самоаудит</option>
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Активация</Form.Text>
                                <Form.Select id="activation">
                                    <option value="on_demand">По требованию</option>
                                    <option value="by_datetime">По расписанию</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col md={4}>
                                <Form.Text>Доступ к результатам</Form.Text>
                                <Form.Check
                                id="results_access"
                                type="switch" 
                                label="Не давать/Дать"/>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Дата начала</Form.Text>
                                <Form.Control 
                                required
                                id="start_datetime"
                                type="datetime-local" 
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Text>Дата окончания</Form.Text>
                                <Form.Control 
                                required
                                id="end_datetime"
                                type="datetime-local" 
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col md={4}>
                            <Form.Text>Самоаудит</Form.Text>
                             <Select 
                                id="esteem_audit"
                                placeholder="Самоаудит..."
                                value={esteemAuditValue}
                                onChange={(e)=>setEsteemAuditValue(e)}
                                options={selfEsteemOption}
                                className="mb-2"
                                isClearable/>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Завод</Form.Text>
                                <Select 
                                id="facility_id"
                                placeholder="Завод..." 
                                value={facilityValue}
                                onChange={(e)=>setFacilityValue(e)}
                                options={facilityOptions} 
                                isClearable 
                                className="mb-2"
                                required/>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Лидер аудита</Form.Text>
                                <Select 
                                id="audit_leader"
                                placeholder="Лидер аудита..." 
                                value={leaderValue}
                                onChange={(e)=>setLeaderValue(e)}
                                options={usersOptions} 
                                isClearable 
                                className="mb-2"
                                required/>
                            </Col>
                        </Row>
                    </div>
                    </Card.Body>
                </Card>
                <Accordion className="mt-1" defaultActiveKey={"auditBlock"} alwaysOpen flush>
                    <Accordion.Item className="mb-1 border" eventKey="auditBlock">
                        <Accordion.Header><div className="text_font">Аудиторы</div></Accordion.Header>
                        <Accordion.Body>
                            <Accordion defaultActiveKey="end_false_key">
                                {Object.keys(AuditorsCurrentTestBlock).map((partName, index)=>(
                                    <Accordion.Item key={index} eventKey={index}>
                                        <Accordion.Header><div className="text_font">{partName}</div></Accordion.Header>
                                        <Accordion.Body>
                                            <Tabs
                                            defaultActiveKey="all"
                                            variant="pills"
                                            id="uncontrolled-tab-example"
                                            className="mb-3"
                                            >
                                                <Tab eventKey="all" title="Все">
                                                    <Form.Text className="text_font">Все</Form.Text>
                                                    <Select 
                                                    isMulti 
                                                    placeholder="Аудитор..."
                                                    onChange={(selected)=>{handleSaveCheckedAllValues(partName,selected)}}
                                                    options={usersOptions}
                                                    isClearable/> 
                                                </Tab>
                                                <Tab eventKey="category" title="По подразделам">
                                                    {Object.keys(AuditorsCurrentTestBlock[partName]).map((categoryName)=>(
                                                        <div>
                                                            <Form.Text className="text_font">{shortNames[partName][categoryName]} {categoryName}</Form.Text>
                                                            <Select
                                                            isMulti 
                                                            placeholder="Аудитор..."
                                                            onChange={(selected)=>{handleSaveCheckedCurrentValues(partName,categoryName,selected)}}
                                                            options={usersOptions}
                                                            defaultValue={auditorsCurrentData[partName][categoryName].map((elem)=>{return findOptionByName(elem)})} 
                                                            isClearable/> 
                                                        </div>
                                                    ))}
                                                </Tab>
                                            </Tabs>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </Accordion.Body>   
                    </Accordion.Item>
                </Accordion>
                <Button type="submit" className="m-1" size="lg">Сохранить изменения</Button>
            </Form>
        </>
    )

}

const AuditStructure = ({auditData, dataUsers, dataTest, dataFacility, dataSelfEsteem}) => {
    if (dataUsers.length===0){
        return(<p>В системе нет пользователей! Создайте хотя бы одного пользователя.</p>)
    }
    if (dataFacility.length===0){
        return(<p>В системе нет предприятий! Создайте хотя бы одно предприятие.</p>)
    }

    const usersOptions=dataUsers.map((item, index)=>{return {
        label:`${index+1})${item.surname||""} ${item.name||""} ${item.patronymic || ""}(${item.username})`,
        value:item.username
    }})
    const facilityOptions=dataFacility.map((item,index)=>{
        return{ label:item.short_name, value:item.id}
    })
    const selfEsteemOption=dataSelfEsteem.map((item,index)=>{
        return{label:item.name, value:item.id}
    })
    
    //данныые для отправки
    const AuditorsTestBlock = AuditorsTestStructure(dataTest.data);
    //данные для рендеренга
    //сокращения
    const shortNames=AuditorsTestShortNames(dataTest.data);
    //поля подразделов
    const AuditorsCurrentTestBlock = AuditorsTestStructure(dataTest.data);
    //поле все
    const AuditorsTestBlockAll=AuditorsTestStructureAll(dataTest.data);

    Object.keys(auditData["auditors"]).forEach((partName)=>{
        Object.keys(auditData["auditors"][partName]).forEach((categoryName)=>{
            AuditorsCurrentTestBlock[partName][categoryName]=auditData["auditors"][partName][categoryName];
        })
    })

    return(<>
    <AuditFormInterface
    auditData={auditData}
    usersOptions={usersOptions}
    facilityOptions={facilityOptions}
    selfEsteemOption={selfEsteemOption}
    AuditorsTestBlock={AuditorsTestBlock}
    AuditorsCurrentTestBlock={AuditorsCurrentTestBlock}
    AuditorsTestBlockAll={AuditorsTestBlockAll}
    shortNames={shortNames}
    />
    </>)
}

const FetchOtherData = ({auditData}) => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);

    const [dataUsers,setDataUsers]=useState(null);
    const [dataTest,setDataTest]=useState(null);
    const [dataFacility,setDataFacility]=useState(null);
    const [dataSelfEsteem, setDataSelfEsteem]=useState(null);

    const getUsers = async() => {
        try {
            const response = await Api({
                 method:"get",
                url:`/users/`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о пользователях \n ${error}`
        }
    }

    const getFacility = async()=>{
        try {
            const response = await Api({
                 method:"get",
                url:`/facilities/`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о предприятиях \n ${error}`
        }
    }

    const getTestData = async(test_id)=>{
        try {
            const response = await Api({
                method:"get",
                url:`/tests/@${test_id}`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о тесте ${test_id} \n ${error}`
        }
    }

    const getSelfEsteem = async(test_id)=>{
        try {
            const response = await Api({
                method:"get",
                url:`/audits/my_audits/self-esteem?test_id=${test_id}`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о самоаудитах теста ${test_id} \n ${error}`
        }
    }

    const getAllData = async() => {
        try {
            const userData=await getUsers();
            setDataUsers(userData.data);

            const facilitiesData=await getFacility();
            setDataFacility(facilitiesData.data);

            const testData=await getTestData(auditData.test_id);
            setDataTest(testData.data);

            const selfEsteemData=await getSelfEsteem(auditData.test_id);
            setDataSelfEsteem(selfEsteemData.data);

            setBlock(true);
        } catch (error) {
            setErrorInfo(error);
            setError(true);
        }
    }

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true);
            await getAllData();
            setLoading(false);
        }
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<AuditStructure
        auditData={auditData}
        dataUsers={dataUsers}
        dataTest={dataTest}
        dataFacility={dataFacility}
        dataSelfEsteem={dataSelfEsteem}
    />)}

}

const ChangeAuditFetch = () => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);

    const {audit_id}=useParams()

    const getAuditData = async() => {
        try {
            const response=await Api({
                method:"get",
                url:`/audits/@${audit_id}/full_data`,
                headers:{} 
            })
            setData(response.data);
            setBlock(true)
        } catch (error) {
            setErrorInfo(`Ошибка при получении данных об аудите ${audit_id} \n ${error}`);
            setError(true);
        }
    }

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true);
            await getAuditData();
            setLoading(false);
        }
        setUp();
    },[])

    if (loading){return(<LoadingStuck/>)}
    if (error){return(<p className="warning_text">{errorInfo}</p>)}
    if (block){return(<FetchOtherData auditData={data}/>)}
    // if (block){return(<p> {JSON.stringify(data)}</p>)}
} 

const ChangeAuditBlock = () => {
    return(<ChangeAuditFetch/>)
}

export default ChangeAuditBlock;